import { css } from 'styled-components';
import {
  getSpacing, SpacingName, getTypography, TypographyName, ThemedFunctor,
} from '@doveit/lego';

export const baseStyle: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.margin(theme, [SpacingName.BIG, SpacingName.AUTO])};

  h1,
  h2 {
    ${getTypography(theme, TypographyName.H3)};
    ${getSpacing.margin(theme, [SpacingName.SMALL, SpacingName.ZERO])};
  }

  h3 {
    ${getTypography(theme, TypographyName.H4)};
  }

  p, h4 {
    ${getTypography(theme, TypographyName.BODY)};
    font-weight: 700;
  }

  h4 {
    font-weight: 700;
  }

  ul,
  ol {
    ${getTypography(theme, TypographyName.BODY)};
    ${getSpacing.margin(theme, SpacingName.SMALL)};
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  ul li,
  ol li {
    ${getSpacing.margin(theme, SpacingName.SMALLER)};
  }

  table {
    ${getTypography(theme, TypographyName.BODY)};
    border: 1px solid ${theme.palettes.neutrals.light};
    ${getSpacing.margin(theme, [SpacingName.SMALL, 0])};
    width: 100%;
  }

  tr:nth-child(2n) {
    background-color: ${theme.palettes.neutrals.lighter};
  }

  td {
    border: 1px solid ${theme.palettes.neutrals.light};
    padding: 0.5rem;
  }
`;
